<div class="dropdown-menu shadow dropdown-menu-left animated--grow-in dropdown-list show">
  <h6 class="dropdown-header" style="background-color: #f9750e;border: 1px solid #ff9a66;">
    Menu Principal
  </h6>

  <a class="dropdown-item" href="#" [routerLink]="'/home'" (click)="closeMenu()">
    <i class="fas fa-home fa-sm fa-fw mr-2 text-gray-400"></i>
    Accueil<br>
  </a> 

  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/FichesPaie'">
    <i class="fas fa-file-alt fa-sm fa-fw mr-2 text-gray-400"></i>
    Mes fiches de paie<br>
  </a>

  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/HistoriqueActivation'">
    <i class="fas fa-history fa-sm fa-fw mr-2 text-gray-400">
    </i>Historiques d'activation
  </a>

  <a class="dropdown-item" (click)="closeMenu()" href="#" [routerLink]="'/BulletinsSalaire'" [authorizeRole]>
    <i class="fas fa-tasks fa-sm fa-fw mr-2 text-gray-400"></i>
    Approbation
  </a>

  <a class="dropdown-item" href="#" (click)="closeMenu()" [routerLink]="'/help'">
    <i class="fas fa-info-circle fa-sm fa-fw mr-2 text-gray-400"></i>
    Manuel d'utilisation<br>
  </a>
</div>
